import { Contract } from '@ethersproject/contracts'

export const claimInvDash = async (invDashContract: Contract) => {
    return invDashContract.SelfClaimToMyWallet()
}

export const transferOwnershipInvDash = async (invDashContract: Contract, newBeneficiary: string) => {
    return invDashContract.transferAllLock(newBeneficiary)
}